// SocketTest.js
import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

const SocketTest = () => {
  const [socketMessage, setSocketMessage] = useState(null);

  useEffect(() => {
    // Ensure the URL is using http:// and not https://
    const socket = io(`${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github`, { transports: ['websocket'] });
    
    socket.on('connect', () => {
      console.log('Socket connected');
    });
    
    socket.on('activationStatus', (data) => {
      console.log('Received message:', data);
      alert('Received message:', data);
      setSocketMessage(data);
    });
    
    socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });
    
    return () => socket.disconnect();
  }, []);

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h5">Socket Test</Typography>
      {socketMessage ? (
        <Alert severity="success" sx={{ mt: 2 }}>
          Received: {JSON.stringify(socketMessage)}
        </Alert>
      ) : (
        <Typography variant="body1" sx={{ mt: 2 }}>
          No message received yet.
        </Typography>
      )}
    </Box>
  );
};

export default SocketTest;
